module.exports = __webpack_public_path__ + "zmenseni-prsou_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zmenseni-prsou_4_before_tn.jpg
// module id = 1752
// module chunks = 0